import React, {useId} from 'react';

export default function TraditionalOilLamp() {
    const gradientId = `oil-lamp-${useId().replace(/:/g, '')}`;
    return <svg viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false">
        <defs>
            <linearGradient id={gradientId} x1="12" y1="27" x2="30" y2="42" gradientUnits="userSpaceOnUse">
                <stop stopColor="#c18a59"/>
                <stop offset="1" stopColor="#87472e"/>
            </linearGradient>
        </defs>
        <path d="M33 23c-8-4-7-10-2-17 0 6 8 9 2 17Z" fill="#d9a143"/>
        <path d="M32 22c-3-2-3-5-1-8 0 3 4 5 1 8Z" fill="#ffe7a1"/>
        <path d="M8 27c7 1 14 0 20-2l12-3c-2 11-9 18-18 18-7 0-12-5-14-13Z" fill={`url(#${gradientId})`} stroke="#87472e" strokeWidth="1" strokeLinejoin="round"/>
        <path d="M8 27c9 4 24 0 32-5-10 0-24 5-32 5Z" fill="#75482e" stroke="#d4a466" strokeWidth="1" strokeLinejoin="round"/>
        <path d="m32 25 1-3" stroke="#f4d19a" strokeWidth="1.7" strokeLinecap="round"/>
        <path d="M13 32c6 5 14 4 20-1" stroke="#dda979" strokeWidth="1.1" strokeLinecap="round"/>
        <path d="M18 40h10" stroke="#87472e" strokeWidth="2" strokeLinecap="round"/>
        <path d="m18 34 2 1m5 0 2-1" stroke="#f0cda0" strokeWidth="1.2" strokeLinecap="round"/>
    </svg>;
}
